var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-alt',{attrs:{"img":"https://image.freepik.com/vecteurs-libre/fond-technologie-numerique-fil-maille-reseau_1017-27428.jpg","title":"Liste des références produits"}}),_c('table-view'),_c('upload')],1)}
var staticRenderFns = []

export { render, staticRenderFns }